import { useCurrentUserQuery } from 'api/mypage/users';
import { GlobalStateContext } from 'contexts/global_state_context';
import { MypageStateContext } from 'contexts/mypage_state_context';
import React, { useState, useContext, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';
import { bootChannelTalk, shutdownChannelTalk } from 'utils/channel_talk';
import CookieManager from 'utils/cookie_util';
import { useEffectSkipFirst } from 'utils/hooks';

export const UserAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(CookieManager.hasUserToken());
  const globalState = useContext(GlobalStateContext);
  const mypageState = useContext(MypageStateContext);
  const location = useLocation();
  const currentUserQuery = useCurrentUserQuery();

  useEffect(() => {
    currentUserQuery.refetch();
  }, []);

  useEffectSkipFirst(() => {
    if (currentUserQuery.isSuccess) {
      const user = currentUserQuery.data.user;
      mypageState.setCurrentUser(user);
      bootChannelTalk({
        pluginKey: process.env.REACT_APP_CHANNEL_PLUGIN_KEY,
        memberId: user.memberId,
        memberHash: user.memberHash,
        profile: {
          name: `${user.laboratoryName} ${user.familyName} ${user.givenName}`,
          email: user.email,
          status: 'User',
          organization: `${user.laboratory?.name} ${user.laboratory?.branch}`,
          organizationId: user.laboratory?.id,
          organizationUrl: `${process.env.REACT_APP_PURCHASE_HOST}/admin/laboratories/${user.laboratory?.id}`,
          agentLoginUrl: `${process.env.REACT_APP_PURCHASE_HOST}/admin/users/agents/${user.id}`,
          environment: process.env.REACT_APP_ENV,
        },
        workflowId: process.env.REACT_APP_CHANNEL_WORKFLOW_ID_USER,
      });
    }
  }, [currentUserQuery.dataUpdatedAt]);

  useEffectSkipFirst(() => {
    if (globalState.statusCode === 401) {
      shutdownChannelTalk();
      CookieManager.removeUserToken();
      setIsAuthenticated(false);
    } else if (CookieManager.hasUserToken()) {
      setIsAuthenticated(true);
    }
  }, [globalState.statusCode]);

  return isAuthenticated ? (
    <div>
      <Outlet />
    </div>
  ) : (
    <Navigate to={MypageRouteHelper.login()} state={{ from: location }} replace />
  );
};
